import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ItemService } from './../../services/item.service';
import { Spot } from '../../models/Item';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-competition-timeband',
  templateUrl: './competition-timeband.component.html',
  styleUrls: ['./competition-timeband.component.css']
})
export class CompetitionTimebandComponent implements OnInit {

  constructor(public itemService: ItemService, public router: Router) { }

  CompOne = '';
  CompTwo = '';
  CompThree = '';
  CompFour = '';
  primary = '';
  
  
    chart = [];
    
    // public data: any[];
    // dateSelected: any;
    public daterange: any = {};
    public advertiser: any;
    public options: any = {
      locale: { format: 'MM/DD/YYYY' },
      
      alwaysShowCalendars: false,
      startDate: this.itemService.sd,
      endDate: this.itemService.ed,
      minDate: '01/01/2017',
      // maxDate: '31/03/2017',
      opens: 'left',
      showWeekNumbers: true,
      ranges: {
        // 'Yesterday': [
        //     '2018-02-26T07:00:33.456Z',
        //     '2018-02-26T07:00:33.456Z'
        // ],
        'Last 7 Days': [
          '01/01/2017',
          '01/07/2017'
        ],
        'Last 30 Days': [
          '01/01/2017',
          '01/30/2017'
        ],
        'This Month': [
          '01/01/2017',
          '01/31/2017'
        ],
        'Last Month': [
          '01/01/2017',
          '01/31/2017'
        ]
      },
    };
  
    
  
    public selectedDate(value: any, datepicker?: any) {
      this.itemService.showSpinner = true;
      
      
      datepicker.start = value.start;
      datepicker.end = value.end;
  
      // or manupulat your own internal property
      this.daterange.start = value.start;
      this.daterange.end = value.end;
      this.daterange.label = value.label;
  
      let start;
      let end;
      start = new Date(this.daterange.start);
      end = new Date(this.daterange.end);
  
      // start Date Function
      
      this.itemService.startDate = start;
      // console.log(this.itemService.startDate);
  
      // end Date Function
    
      this.itemService.endDate = end;
      // console.log(this.itemService.endDate);
  
      // dateChanged Function
      
      this.itemService.startDateTemp = new Date(start)
      this.itemService.endDateTemp = new Date(end)
      this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;
  
  
  
      let advertiserSelected = this.itemService.selected_adv ? this.itemService.selected_adv : 'Not Selected';
      let parameters:any = { 
        section_name: 'Publishers',
        page_name: 'Advertisers',
        advertiser:advertiserSelected,
        startDate: this.itemService.startDate,
        days:this.itemService.days,
        endDate: this.itemService.endDate,
      }
      this.itemService.logEvent('onDateChange', parameters);
  
      this.itemService.channelTimeband_One = null;
      this.itemService.channelTimeband_Two = null;
      this.itemService.channelTimeband_Three = null;
      this.itemService.channelTimeband_Four = null;
      this.itemService.fetchPulisher = null;
      this.itemService.fetchPulisherType = null;
  
      
  
      this.itemService.selected_CompOne = null;
      this.itemService.selected_CompTwo = null;
      this.itemService.selected_CompThree = null;
      this.itemService.selected_CompFour = null;
      this.itemService.selected_CompOne = '';
      this.itemService.selected_CompTwo = '';
      this.itemService.selected_CompThree = '';
      this.itemService.selected_CompFour = '';
      this.CompOne = '';
      this.CompTwo = '';
      this.CompThree = '';
      this.CompFour = '';
      this.primary = '';
  
      // this.itemService.dateChangeDetector();
      this.itemService.showSpinner = false;
    }
  
  
   
    onChangeCompOne(value, type) {
  
      this.itemService.startDateTemp = new Date(this.itemService.sd)
      this.itemService.endDateTemp = new Date(this.itemService.ed)
      this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;
  
      let parameters:any = { 
        section_name: 'Publishers',
        page_name: 'Missing Report',
        advertiser:value,
        startDate: this.itemService.startDateTemp,
        days: this.itemService.days,
        endDate: this.itemService.endDateTemp,
      }
      this.itemService.logEvent('onAdvertiserChange', parameters);
  
      this.itemService.selected_CompOne = value;
      this.itemService.fetchPulisher = value;
      this.itemService.fetchPulisherType = type;
      this.itemService.fetchPublishers(value, type);
    }
  
    onChangeCompTwo(value, type) {
  
      this.itemService.startDateTemp = new Date(this.itemService.sd)
      this.itemService.endDateTemp = new Date(this.itemService.ed)
      this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;
  
      let parameters:any = { 
        section_name: 'Publishers',
        page_name: 'Missing Report',
        advertiser:value,
        startDate: this.itemService.startDateTemp,
        days: this.itemService.days,
        endDate: this.itemService.endDateTemp,
      }
      this.itemService.logEvent('onAdvertiserChange', parameters);
  
      this.itemService.selected_CompTwo = value;
      this.itemService.fetchPulisher = value;
      this.itemService.fetchPulisherType = type;
      this.itemService.fetchPublishers(value, type);
    }
  
    onChangeCompThree(value, type) {
  
      this.itemService.startDateTemp = new Date(this.itemService.sd)
      this.itemService.endDateTemp = new Date(this.itemService.ed)
      this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;
  
      let parameters:any = { 
        section_name: 'Publishers',
        page_name: 'Missing Report',
        advertiser:value,
        startDate: this.itemService.startDateTemp,
        days: this.itemService.days,
        endDate: this.itemService.endDateTemp,
      }
      this.itemService.logEvent('onAdvertiserChange', parameters);
  
      this.itemService.selected_CompThree = value
      this.itemService.fetchPulisher = value;
      this.itemService.fetchPulisherType = type;
      this.itemService.fetchPublishers(value, type);
    }
  
    onChangeCompFour(value, type) {
  
      this.itemService.startDateTemp = new Date(this.itemService.sd)
      this.itemService.endDateTemp = new Date(this.itemService.ed)
      this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;
  
      let parameters:any = { 
        section_name: 'Publishers',
        page_name: 'Missing Report',
        advertiser:value,
        startDate: this.itemService.startDateTemp,
        days: this.itemService.days,
        endDate: this.itemService.endDateTemp,
      }
      this.itemService.logEvent('onAdvertiserChange', parameters);
  
      this.itemService.selected_CompFour = value;
      this.itemService.fetchPulisher = value;
      this.itemService.fetchPulisherType = type;
      this.itemService.fetchPublishers(value, type);
    }
  
   
   
  
    
  
    ngOnInit() {
  
      this.itemService.selected_primaryChannel = null;
      this.CompOne = '';
      this.CompTwo = '';
      this.CompThree = '';
      this.CompFour = '';
      this.primary = '';
  
      this.itemService.Top20Advertisers_One = null;
      this.itemService.Top20Advertisers_Two = null;
      this.itemService.Top20Advertisers_Three = null;
      this.itemService.Top20Advertisers_Four = null;
       
      let parameters:any = { section_name: 'Publishers', page_name: 'Missing Reports'}
        this.itemService.logEvent('onPageView', parameters);
  
     
      
      this.itemService.showSpinner = true;
      this.itemService.url =this.router.url;   
      
      // this.itemService.dateChangeDetector();
      this.itemService.showSpinner = false;
      
    }
  
  }


// WEBPACK FOOTER //
// ./src/app/publishers/competition-timeband/competition-timeband.component.ts